import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // pagination
    const page = data.page ? data.page : 1
    return axios.get(process.env.API_ENDPOINT + '/invoice?client_id=' + data.client_id + '&date_from=' + data.date_from + '&date_to=' + data.date_to + '&status=' + data.status + '&token=' + VueCookies.get('token') + '&page=' + page + limit)
  },
  getCompletedClass (data) {
    return axios.get(process.env.API_ENDPOINT + '/invoice/completed-classes?client_id=' + data.client_id + '&date_from=' + data.date_from + '&date_to=' + data.date_to + '&token=' + VueCookies.get('token'))
  },
  generateInvoice (data) {
    return axios.post(process.env.API_ENDPOINT + '/invoice?token=' + VueCookies.get('token'), data)
  },
  bulkAction (data) {
    return axios.post(process.env.API_ENDPOINT + '/invoice/' + data.action + '?token=' + VueCookies.get('token'), {invoice_ids: data.ids})
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/invoice/' + id + '?token=' + VueCookies.get('token'))
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/invoice/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/invoice/' + id + '?token=' + VueCookies.get('token'), data)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/invoices.js